import createLucideIcon from '../createLucideIcon';

const Space = createLucideIcon('Space', [
  ['polyline', { points: '22,17 22,19 2,19 2,17', key: 'w01tig' }],
]);

export default Space;
